export const ACTION_FORMAT = 'v1';
export const APP_INSTANCE_RESOURCE_FORMAT = 'v1';
